"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#004864",
    points: "11.99 11.93 2.07 5.98 11.99 0.03 21.91 5.98 11.99 11.93"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#004864",
    points: "11.71 23.97 1.85 18.05 1.85 6.48 11.71 12.44 11.71 23.97"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#004864",
    points: "22.15 18.05 12.24 23.97 12.24 12.44 22.15 6.48 22.15 18.05"
  })));
};

exports["default"] = _default;